/**
 * Mappers for area update operations
 */

import type {
  UpdateAreaRequest,
  UpdateAreaResult,
  LC_UpdateCompanyAreaIn,
  LC_UpdateCompanyAreaOut,
} from '../types';

/**
 * Map update area request from domain to transport
 */
export function mapUpdateAreaToTransport(
  request: UpdateAreaRequest,
): LC_UpdateCompanyAreaIn {
  return {
    areaCode: request.code,
    areaName: request.name,
    parentAreaId: request.parentAreaId,
  };
}

/**
 * Map update area response from transport to domain
 */
export function mapUpdateAreaFromTransport(
  transport: LC_UpdateCompanyAreaOut,
): UpdateAreaResult {
  return {
    id: transport.areaId,
    code: transport.areaCode,
    name: transport.areaName,
    parentAreaId: transport.parentAreaId,
    parentAreaName: transport.parentAreaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate,
    modifiedBy: transport.modifiedBy,
  };
}
